<template>
  <div>
    <main class="policy-management_container">
      <section class="container__header">
        <label class="container__header--topic text--topic">Policy List</label>
        <div v-if="hasUpdatePermission" class="header__button">
          <atom-button
            buttonId="create-new-policy-button"
            @click="createNewPolicy"
          >
            Create New Policy
          </atom-button>
        </div>
        <div v-if="hasUpdatePermission" class="header__button--phone">
          <atom-button
            buttonId="create-new-policy-button"
            iconLeft="PlusIcon"
            @click="createNewPolicy"
          >
          </atom-button>
        </div>
      </section>
      <section class="container__content">
        <molecule-data-table
          v-model="inputSearch"
          :fields="hasUpdatePermission ? fields: fields.filter(field => field.field !== 'delete')"
          :items="items"
          :isCustomized="true"
          :enabledSelect="false"
          :enabledSearch="true"
          :isShowPagination="false"
          :fixed-header="true"
          placeholderSearch="Filter Policies"
          @onRowClick="onRowClick"
          @onRowDoubleClick="onRowDoubleClick"
          maxHeight="568px"
        >
          <template #leftOfSearch>
            <div class="searchbox__container">
            </div>
          </template>

          <template #id="data">
            <span class="data-table__id--style">#{{ data.row.id }}</span>
          </template>
          <template #name="data">
            <span class="data-table__text--style">{{ data.row.name }}</span>
          </template>
          <template #updateDate="data">
            <span class="data-table__text--style">{{
              data.row.updateDate
            }}</span>
          </template>
          <template #description="data">
            <span class="data-table__text--style">{{
              data.row.description
            }}</span>
          </template>
          <template #delete="data">
            <div
              v-if="!data.row.isPolicyDefault"
              class="text-center pr-1 button__delete"
              @click.stop="deletePolicyClick(data)"
            >
              <feather-icon icon="Trash2Icon" class="data-table__icon--style" />
            </div>
          </template>
        </molecule-data-table>
      </section>
      <section class="container__footer">
        <span class="text--entries text-secondary">
          Showing {{ items.length }} entries
        </span>
      </section>

      <molecule-modal-dialog
        v-if="equipmentData.length === 0"
        modalId="modal-confirm-delete-policy"
        icon="AlertCircleIcon"
        :isTextCenter="true"
        :textTitle="`Do you want to delete\n“${selectPolicy.name}” ?`"
        textSubtitle="You won’t be able to revert this!"
        buttonTextLeft="Delete"
        buttonColorLeft="danger"
        @clickButtonLeft="clickConfirmDelete"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        v-if="equipmentData.length > 0"
        modalId="modal-confirm-delete-policy"
        icon="AlertCircleIcon"
        :isTextCenter="true"
        :textTitle="`Do you want to delete\n“${selectPolicy.name}” ?`"
        buttonTextLeft="Delete"
        buttonColorLeft="danger"
        :isSlotBody="true"
        @clickButtonLeft="clickConfirmDelete"
      >
        <template #body>
          <div class="modal-confirm-delete-policy__list--full">
            <label class="list__title text-center"
              >“{{ selectPolicy.name }}” currently applied to equipment list.<br />After
              deletion, equipment list policy will be reset to “Default
              Policy”.</label
            >
            <ul class="list__ul">
              <li
                v-for="(equipment, index) in equipmentData"
                :key="index"
                class="list__li"
              >
                <label class="list__label">{{ equipment.hostname }}</label>
              </li>
            </ul>
            <div>
              <atom-checkbox
                title="Disable Monitoring and policy on equipment list"
                textStyle="fontSize:12px;"
                v-model="isDisableMonitoring"
              ></atom-checkbox>
            </div>
          </div>
        </template>
      </molecule-modal-dialog>
    </main>
    <footer style="height: 28px"></footer>
  </div>
</template>

<script>
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeDataTable from "@/components/molecules/MoleculeDataTable.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
import { checkPolicyManagementById } from "@/api/api-module"
import { PermissionUser } from "@/constants/permission-user"
import mixins from "@/mixins"
import mixinsUser from "@/mixins/mixinsUser"

export default {
  name: "OrganismPolicyManagement",
  mixins: [mixins, mixinsUser],
  components: {
    AtomInput,
    AtomButton,
    MoleculeDataTable,
    MoleculeModalDialog,
    AtomCheckbox,
  },
  props: {
    fields: {
      type: Array,
      required: false,
      default: [],
    },
    items: {
      type: Array,
      required: false,
      default: [],
    },
  },
  data() {
    return {
      inputSearch: "",
      selectPolicy: {},
      modalId: "",
      equipmentData: [],
      isDisableMonitoring: false,
    }
  },
  emits: ["deletePolicy"],
  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.SMS.POLICY_WRITE)
    },
  },
  methods: {
    // create new policy
    createNewPolicy() {
      this.$router.push("/server-management/policy/create")
    },

    // click row
    onRowClick(param) {
      this.$router.push("/server-management/policy/edit/" + param.row.id)
    },
    onRowDoubleClick() {},

    // click delete button in table
    deletePolicyClick(param) {
      this.selectPolicy = param.row
      this.checkPolicyUsed(param.row.id)
      this.modalId = "modal-confirm-delete-policy"
      this.$bvModal.show(this.modalId)
    },
    // check policy used
    checkPolicyUsed(id) {
      this.showLoading(true)
      this.equipmentData = []
      checkPolicyManagementById(id).then((response) => {
        response.forEach((equipment) => {
          this.equipmentData.push({
            equipmentId: equipment.equipmentId,
            hostname: equipment.hostname,
          })
        })
        this.showLoading(false)
      })
    },

    // click delete button in model
    clickConfirmDelete() {
      this.$emit("deletePolicy", this.selectPolicy.id, this.isDisableMonitoring)
      this.closeModal()
    },
    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },
  },
}
</script>

<style lang="scss" scoped>
.policy-management_container
  ::v-deep
  .molecule-datatable--header-search-container {
  //display: flex;
  //justify-content: center;
  //flex-direction: row;
  display: block;
  padding-right: 21px;
}

.policy-management_container {
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  padding-bottom: 10px;
}

.container__header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.5rem 1.5rem 0 1.5rem;
}

.text--topic {
  font-weight: 500;
  font-size: 18px;
}

.header__button {
  display: none;
}

.searchbox__container {
  display: flex;
  align-items: flex-end;
  margin-top: 10px;
  margin-left: 22px;
}

.searchbox--style {
  min-width: 238px;
}

.data-table__id--style {
  color: #7367f0;
  padding-left: 7px;
  font-weight: 600;
  font-size: 14px;
}

.data-table__text--style {
  font-weight: 400;
  font-size: 14px;
}

.button__delete {
  color: #5e5873;
  &:hover {
    color: #ea5455;
    transition: color 0.15s linear;
  }
}

.data-table__icon--style {
  height: 20px;
  width: 20px;
}

.container__footer {
  padding: 1.5rem;
}

.text--entries {
  padding-left: 10px;
  font-size: 14px;
}

.modal-confirm-delete-policy__list--full {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  max-width: 100%;
  align-items: center;
}
.list__title {
  margin-bottom: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #6e6b7b;
}
.list__title--medium {
  font-weight: 500;
}
.list__ul {
  margin-bottom: 15px;
  padding-left: 16px;
  max-height: 122px;
  overflow-y: auto;
  max-width: 250px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}
.list__li {
  color: #babfc7;
}
.list__label {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 6px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .header__button {
    display: block;
  }
  .header__button--phone {
    display: none;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .policy-management_container
    ::v-deep
    .molecule-datatable--header-search-container {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    padding-right: 0;
  }
  .searchbox__container {
    margin-left: 22px;
    align-items: flex-end;
    margin-top: 0;
  }
  .searchbox--style {
    width: 378px;
  }
  .container__header {
    justify-content: space-between;
    flex-direction: row;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
